import React from 'react';
import Avatar from 'shared/components/avatar/Avatar';
import { calculateLastActive } from 'utils/date';

export default function AssessmentHead({ client }) {
  const firstLetters =
    client.first_name && client.last_name
      ? `${client.first_name[0].toUpperCase()}${client.last_name[0].toUpperCase()}`
      : '';

  const text = client.last_active
    ? `Last Active ${calculateLastActive(client.last_active)} ago`
    : 'Invited to Hybrid';

  return (
    <div className="assessment-template-head">
      <Avatar
        src={client.photo || ''}
        firstLetters={firstLetters}
        width="36"
        height="36"
        name={`${client.first_name} ${client.last_name}`}
        text={text}
        url={`/clients/${client.id}`}
      />
    </div>
  );
}
